/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const divorceAgreementSectionStyle = {
  container: {
    textAlign: "center",
  },
  header: {
    marginBottom: "30px",
  },
  text: {
    textAlign: "left",
  },
  infoButton: {
    margin: "0 auto",
  },
};

export default divorceAgreementSectionStyle;
